import PropTypes from 'prop-types'
import styled from 'styled-components'

import RequiredLegend from 'components/Shared/TableForm/RequiredLegend'
import Button from 'components/Shared/Button/Index'

const StyledSidebarSectionFormSubmit = styled.section`
  padding: 12px 16px 16px 16px;
`

const ButtonWrapper = styled.div`
  display: flex;
  margin-top: 32px;
  justify-content: center;
`

const SidebarSectionFormSubmit = ({ withRequiredLegend, disabled, buttonLabel, onClick }) => {
  return (
    <StyledSidebarSectionFormSubmit>
      {withRequiredLegend &&
        <RequiredLegend isVisible />
      }

      <ButtonWrapper>
        <Button large disabled={disabled} onClick={onClick}>
          {buttonLabel}
        </Button>
      </ButtonWrapper>
    </StyledSidebarSectionFormSubmit>
  )
}

SidebarSectionFormSubmit.propTypes = {
  withRequiredLegend: PropTypes.bool,
  disabled: PropTypes.bool,
  buttonLabel: PropTypes.string,
  onClick: PropTypes.func,
}

export default SidebarSectionFormSubmit
